// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","314":"setting"}[chunkId] + "." + {"177":"81b8b711","314":"f0a2fb4b"}[chunkId] + ".css";
};